export default __webpack_public_path__ + "assets/images/4b140181aabc14eda10bdc435dbd6a2a.svg";